import React, { Suspense } from "react";
import AllRoute from "../router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "../../context/AuthProvider";
import { LangProvider } from "../../context/LangContext";
import { I18nextProvider } from "react-i18next";
import i18n from "../../context/i18n";
import "../../css/font-arabic.css"; // Arabic font styles
import "../../css/flaticon.css"; // English font styles
import { useLang } from "../../context/LangContext";

const queryClient = new QueryClient();

const AppContent = () => {
   const { lang } = useLang();
    const isArabic = lang === "ar";
    
  return (
    <LangProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <I18nextProvider i18n={i18n}>
          <QueryClientProvider client={queryClient}>
            <div className={`App ${isArabic ? "arabic-font" : "english-font"}`} dir={isArabic ? "rtl" : "ltr"}>
            <AuthProvider>
              <AllRoute />
              <ToastContainer />
            </AuthProvider>
            </div>
          </QueryClientProvider>
        </I18nextProvider>
      </Suspense>
    </LangProvider>
  );
};

const App = () => {
  return (
    <LangProvider>
      <AppContent />
    </LangProvider>
  );
};

export default App;
